var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 18.333H14.9999V16.6663C14.9999 15.2856 13.8807 14.1663 12.4999 14.1663H7.49992C6.11921 14.1663 4.99992 15.2856 4.99992 16.6663V18.333H3.33325V16.6663C3.33325 14.3652 5.19874 12.4997 7.49992 12.4997H12.4999C14.8011 12.4997 16.6666 14.3652 16.6666 16.6663V18.333ZM9.99992 10.833C7.23849 10.833 4.99992 8.59442 4.99992 5.83301C4.99992 3.07158 7.23849 0.833008 9.99992 0.833008C12.7613 0.833008 14.9999 3.07158 14.9999 5.83301C14.9999 8.59442 12.7613 10.833 9.99992 10.833ZM9.99992 9.16634C11.8408 9.16634 13.3333 7.67396 13.3333 5.83301C13.3333 3.99206 11.8408 2.49967 9.99992 2.49967C8.15897 2.49967 6.66659 3.99206 6.66659 5.83301C6.66659 7.67396 8.15897 9.16634 9.99992 9.16634Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7f34356289090df8773ef17afc58d465.svg";
export { ForwardRef as ReactComponent };